import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getLiveness } from "@/lib/api/generated/nextsub";

export function BuildVersionFooter() {
  const { t } = useTranslation();
  const api = useQuery({
    queryKey: ["public", "control-plane-version"],
    queryFn: () => getLiveness({ anonymous: true, credentials: "omit" }),
    staleTime: 60_000,
    retry: false,
    meta: { silent: true },
  });
  const webVersion = import.meta.env.VITE_APP_VERSION?.trim() || "dev";
  const apiVersion = api.data?.version?.trim();
  return (
    <footer className="border-t border-border px-4 py-3 text-center font-mono text-[11px] leading-5 text-fg-subtle break-all">
      <span className="block sm:inline">{t("shell.webVersion", { version: webVersion })}</span>
      {apiVersion ? (
        <span className="block sm:ml-4 sm:inline">{t("shell.apiVersion", { version: apiVersion })}</span>
      ) : null}
    </footer>
  );
}
